import React, { useState, useContext } from 'react'
import { useMutation } from '@apollo/client'
import dayjs from 'dayjs'
import { Card } from 'antd'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LEGAL_FORMALITY_ADD_NOTE_MUTATION } from 'graphql/LegalFormalities'
import { NotesWrapper } from './styles'
import { Note } from 'types/legalFormality'
import styled from 'styled-components'

const InternalNotes = () => {
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const formalityNotes = legalFormality && legalFormality.internalNotes
  const notes = formalityNotes && JSON.parse(formalityNotes)
  const [note, setNote] = useState('')
  const [addNote, { loading }] = useMutation(LEGAL_FORMALITY_ADD_NOTE_MUTATION)

  // TODO: handle errors
  const saveNote = () => {
    addNote({ variables: { id: legalFormality.id, text: note } }).then(() =>
      setNote('')
    )
  }

  return (
    <InternalNotesWrapper>
      internal notes
      <br />
      <textarea value={note} onChange={e => setNote(e.target.value)} />
      <br />
      <button onClick={saveNote} disabled={loading}>
        save
      </button>
      {notes && (
        <NotesWrapper>
          {notes &&
            notes
              .sort((a: Note, b: Note) => {
                return (
                  new Date(b.madeAt).getTime() - new Date(a.madeAt).getTime()
                )
              })
              .map((note: Note, i: number) => (
                <Card
                  key={`note-${i}`}
                  title={`${dayjs(note.madeAt).format('DD/MM/YYYY HH:mm:ss')} ${
                    note.username
                  }`}
                >
                  <p>{note.text}</p>
                </Card>
              ))}
        </NotesWrapper>
      )}
    </InternalNotesWrapper>
  )
}

export default InternalNotes

const InternalNotesWrapper = styled.div`
  width: 100%;
  text-align: center;
  overflow-y: auto;

  textarea {
    min-width: 80%;
    max-width: 100%;
    min-height: 110px;
  }
`
